export default "__VITE_ASSET__GXzS$ttf__"